import React, { Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/style.scss'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import ScrollToTop from './components/ScrollToTop'
import Home from './layouts/Home'
import SurveyLayout from './layouts/SurveyLayout'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './styles/print.css'

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <ScrollToTop />
        <Routes>
          <Route path="/*" element={<Home />} />
          <Route exact path="/assessment/*" name="survey" element={<SurveyLayout />} />
        </Routes>
      </Suspense>
      <ToastContainer position="top-center" />
    </BrowserRouter>
  )
}

export default App
